<template>
	<div>
		<loading :active.sync="isLoading"></loading>
		<transactionManage :transaction="row" v-if="row"/>
		<div class="row pt-5" v-if="row">
			<div class="col-m-12 col-xl-12 text-left">
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.amount }}
					</span>
						{{ row.amount | toMoney(row.currency) }}
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.user.username }}
					</span>
						<router-link :to="{name: 'userprofile', params: {id: row.user.id}}">
							{{ row.user.username }} ({{ row.user.balance | toMoney(row.user.currency) }})
						</router-link>
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.description }}
					</span>
						{{ row.info }}
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.status }}
					</span>
						{{ row.status }}
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.old_real_money }}
					</span>
						{{ row.oldRealMoney | toMoney(row.currency) }}
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.new_real_money }}
					</span>
						{{ row.newRealMoney | toMoney(row.currency) }}
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.old_bonus }}
					</span>
						{{ row.oldBonus | toMoney(row.currency) }}
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.new_bonus}}
					</span>
						{{ row.newBonus | toMoney(row.currency) }}
					</div>
				</div>
			</div>
			<div class="col-12">
				<BankAccountDetail :id="row.dataId" v-if="row.dataId && row.type.key == 'withdraw_transfer_to_bank_account'" />
			</div>
		</div>
	</div>
</template>

<script>

	import transactionManage from '@/components/accounting/transactionManage'
	import BankAccountDetail from '@/components/accounting/BankAccountDetail'
    export default {
        name: 'transactionDetail',
	    components: {BankAccountDetail, transactionManage},
	    props: {
            id: {
                default: 0
            }
	    },
        data () {
            return {
                api: window.api,
                t: this.$root.t,
                row: null,
	            status: 0,
	            isLoading: false,
            }
        },
	    mounted () {
            this.fetchTransaction();
	    },
	    methods: {

            fetchTransaction () {
                this.isLoading = true;
                this.$http.get(api+'api/v1/user/transactions', { params:{transactionId: [this.id], _: Date.now()} }).then(
                    response => {
                    // get body data
	                this.row = response.body.result.transactions[0];
	                this.isLoading = false;
	                this.status = response.status;

                }, response => {
                    this.isLoading = false;
                    this.status = response.status;

                })
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/transactionDetail.vue